var spotApiUrl = "https://api.binance.com/api"
var futuresApiUrl = "https://fapi.binance.com/fapi"

export default {

    loadSpotExchangeInfo() {
      var exchangeInfo = spotApiUrl + "/v3/exchangeInfo"
      var self = this
      this.spotSymbols = []
      fetch(exchangeInfo)
          .then(response => response.json())
          .then(data => {
              data.symbols.map(function(item, key) {
                  item.exchange = "Binance"
                  item.type = "Crypto Spot"
                  self.spotSymbols.push(item)
              })
      })
      return this.spotSymbols
    },
    loadFuturesExchangeInfo() {
      var exchangeInfo = futuresApiUrl + "/v1/exchangeInfo"

      var self = this
      this.futureSymbols = []
      fetch(exchangeInfo)
          .then(response => response.json())
          .then(data => {
              data.symbols.map(function(item, key) {
                  item.exchange = "Binance"
                  item.type = "Crypto Futures"
                  self.futureSymbols.push(item)
              })
      })

      return this.futureSymbols
    },
    async loadKlineFromBinance(symbol, tf, endTime) {
        var baseUrl = spotApiUrl + "/v3/klines"
        var q_symbol = symbol.toUpperCase().replace("/", "")
        var limit = 1000
        if (tf !== "1M")
            tf = tf.toLowerCase()
        if (q_symbol.indexOf(".P") > 0) {
            baseUrl = futuresApiUrl + "/v1/klines"
            q_symbol = q_symbol.replace(".P", "")
            limit = 1000
        }
        return await fetch(baseUrl + "?symbol=" + q_symbol + "&interval=" + tf + "&limit=" + limit + (Number.isFinite(endTime) ? "&endTime=" + endTime : ""))
    },
    createFuturesWs() {
      this.binance_futures_connection = new WebSocket("wss://fstream.binance.com/market/stream")
    },
    connectFuturesWs(onmessage, onstatus) {
        this._futuresHandler = onmessage;
        this._futuresStatus = onstatus;
        const connection = this.binance_futures_connection;
        connection.onmessage = event => {
            try {
                const data=JSON.parse(event.data);
                if(data.code !== undefined && data.msg) { onstatus?.('error', data.msg); return; }
            } catch (_) { /* The chart handler reports malformed payloads. */ }
            onmessage(event);
        };
        connection.onerror = () => onstatus?.('error', 'Binance connection failed; retrying when the socket closes.');
        connection.onopen = () => {
            this._futuresStatus?.('connected');
            this._futuresAttempts = 0;
            if (this._futuresSubscription) connection.send(this._futuresSubscription);
        };
        connection.onclose = () => {
            if (this.binance_futures_connection !== connection) return;
            this._futuresStatus?.('reconnecting');
            const delay = Math.min(1000 * 2 ** (this._futuresAttempts || 0), 30000);
            this._futuresAttempts = (this._futuresAttempts || 0) + 1;
            clearTimeout(this._futuresReconnectTimer);
            this._futuresReconnectTimer = setTimeout(() => {
                if (this.binance_futures_connection !== connection) return;
                this.createFuturesWs();
                this.connectFuturesWs(this._futuresHandler, this._futuresStatus);
            }, delay);
        };
    },
    sendFuturesWs(message) {
        this._futuresSubscription = message;
        this.last_futures_message = message.replace("SUBSCRIBE", "UNSUBSCRIBE");
        const connection = this.binance_futures_connection;
        if (connection && connection.readyState === WebSocket.OPEN) connection.send(message);
    },
    terminateFuturesWs() {
        clearTimeout(this._futuresReconnectTimer);
        this._futuresSubscription = null;
        if (this.binance_futures_connection) {
            this.binance_futures_connection.onclose = null;
            this.binance_futures_connection.close();
            this.binance_futures_connection = null;
        }
    },
    createSpotWs() {
      this.binance_spot_connection = new WebSocket("wss://stream.binance.com:443/stream")
    },
    connectSpotWs(onmessage, onstatus) {
        this._spotHandler = onmessage;
        this._spotStatus = onstatus;
        const connection = this.binance_spot_connection;
        connection.onmessage = event => {
            try {
                const data=JSON.parse(event.data);
                if(data.code !== undefined && data.msg) { onstatus?.('error', data.msg); return; }
            } catch (_) { /* The chart handler reports malformed payloads. */ }
            onmessage(event);
        };
        connection.onerror = () => onstatus?.('error', 'Binance connection failed; retrying when the socket closes.');
        connection.onopen = () => {
            this._spotStatus?.('connected');
            this._spotAttempts = 0;
            if (this._spotSubscription) connection.send(this._spotSubscription);
        };
        connection.onclose = () => {
            if (this.binance_spot_connection !== connection) return;
            this._spotStatus?.('reconnecting');
            const delay = Math.min(1000 * 2 ** (this._spotAttempts || 0), 30000);
            this._spotAttempts = (this._spotAttempts || 0) + 1;
            clearTimeout(this._spotReconnectTimer);
            this._spotReconnectTimer = setTimeout(() => {
                if (this.binance_spot_connection !== connection) return;
                this.createSpotWs();
                this.connectSpotWs(this._spotHandler, this._spotStatus);
            }, delay);
        };
    },
    sendSpotWs(message) {
        this._spotSubscription = message;
        this.last_spot_message = message.replace("SUBSCRIBE", "UNSUBSCRIBE");
        const connection = this.binance_spot_connection;
        if (connection && connection.readyState === WebSocket.OPEN) connection.send(message);
    },
    terminateSpotWs() {
        clearTimeout(this._spotReconnectTimer);
        this._spotSubscription = null;
        if (this.binance_spot_connection) {
            this.binance_spot_connection.onclose = null;
            this.binance_spot_connection.close();
            this.binance_spot_connection = null;
        }
    },
    destroyWs() {
        this.terminateSpotWs();
        this.terminateFuturesWs();
        this._spotAttempts = this._futuresAttempts = 0;
    }
}
